import { render, staticRenderFns } from "./ot-form-modal-wrapper.vue?vue&type=template&id=4841ebd7&scoped=true&"
import script from "./ot-form-modal-wrapper.vue?vue&type=script&lang=ts&"
export * from "./ot-form-modal-wrapper.vue?vue&type=script&lang=ts&"
import style0 from "./ot-form-modal-wrapper.vue?vue&type=style&index=0&id=4841ebd7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4841ebd7",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VForm } from 'vuetify/lib/components/VForm';
installComponents(component, {VBtn,VDivider,VForm})
